// src/components/LogoutButton.jsx
import { Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../api/auth';

export default function LogoutButton() {
  const nav = useNavigate();
  const onClick = () => {
    logout();
    nav('/login');
  };
  return <Button variant="ghost" onClick={onClick} className="demo_logout">Logout</Button>;
}
